import { Controller } from '@hotwired/stimulus'

// Turbo loads a lazy frame when it scrolls into view, which it decides by observing the frame's
// box. A frame in a closed fold has no box, and this app's frames are display:contents even once
// shown — so nothing is ever observed and a lazy frame inside a fold would wait forever.
// Opening the fold is the trigger instead, and a fold that starts open is already opened.
export default class extends Controller<HTMLDetailsElement> {
  connect(): void {
    this.revealDeferredContent()
  }

  revealDeferredContent(): void {
    if (!this.element.open) return

    this.element
      .querySelectorAll('turbo-frame[loading="lazy"]')
      .forEach(frame => frame.setAttribute('loading', 'eager'))
  }
}
